import AmericanCompanyContext from "components/company/v3/context/AmericanCompanyContext";
import BrazilianCompanyContext from "components/company/v3/context/BrazilianCompanyContext";
import BrazilianRealEstateFundContext from "components/company/v3/context/BrazilianRealEstateFundContext";
import type { IAmericanCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/AmericanCompanyIssuerTopLevel.generated";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import type { IBrazilianRealEstateFundTopLevelFragment } from "lib/fragments/__generated__/BrazilianRealEstateFundTopLevel.generated";
import { useContext } from "react";

export default function useRootIssuer() {
  const americanIssuer = useContext(AmericanCompanyContext);
  const brazilianIssuer = useContext(BrazilianCompanyContext);
  const brazilianRealEstateFundIssuer = useContext(BrazilianRealEstateFundContext);
  const issuer:
    | IAmericanCompanyIssuerTopLevelFragment
    | IBrazilianCompanyIssuerTopLevelFragment
    | IBrazilianRealEstateFundTopLevelFragment
    | null = americanIssuer || brazilianIssuer || brazilianRealEstateFundIssuer;
  if (!issuer) {
    throw new Error("No root issuer found. Make sure you're using this hook inside a issuer's context");
  }
  return issuer;
}
